import axios from 'axios';

const CONFIG_BASE_URL = '/api';

export const axiosInstance = axios.create({
  baseURL: CONFIG_BASE_URL,

  transformResponse: [
    data => {
      try {
        if (data.startsWith(")]}',\n")) {
          return JSON.parse(data.slice(6));
        }
        return data;
      } catch (error) {
        throw Error(
          `Error parsing response JSON data - ${JSON.stringify(error)}`,
        );
      }
    },
  ],
});
